const nav = document.querySelector('.header-nav');

// Only run if nav element exists
if (nav) {
  const toggle = nav.querySelector('.nav-toggle');

  if (toggle) {
    toggle.addEventListener('click', (evt) => {
      evt.stopPropagation();

      if (nav.classList.contains('active')) {
        nav.classList.remove('active');
      } else {
        nav.classList.add('active');
      }
    });
  }
}
